import React from 'react';

import { Button, Grid2 as Grid, styled } from '@mui/material';

import { DownloadIconSmall } from '../../../../assets/icons';
import ResponsiveGrid from '../../../layout/grid';
import { LinkProps } from '../types';

type BrochureDownloadTeaserProps<T extends React.ElementType> = {
  headlineLarge: string;
  image: React.ReactElement;
  headline: string;
  text: string;
  buttonText?: string;
  link: LinkProps<T> & {
    onClick?: () => void;
  };
};

export const BrochureDownloadTeaser = <T extends React.ElementType>({
  headlineLarge,
  image,
  headline,
  text,
  buttonText,
  link,
}: BrochureDownloadTeaserProps<T>) => (
  <ConversionContainer>
    <Grid size={12}>
      <Title>{headlineLarge}</Title>
    </Grid>
    <Grid size={{ xs: 6, md: 3 }} offset={{ xs: 0, md: 3 }}>
      {image}
    </Grid>
    <Grid size={{ xs: 6, md: 5 }}>
      <Headline>{headline}</Headline>
      <Text>{text}</Text>
      {buttonText && link ? (
        <Button
          startIcon={<DownloadIconSmall />}
          component={link.component}
          {...link.props}
          variant="contained"
          color="primary"
          sx={{ width: ['100%', 'auto'] }}
          onClick={() => (link.onClick ? link.onClick() : null)}
        >
          {buttonText}
        </Button>
      ) : null}
    </Grid>
  </ConversionContainer>
);

const ConversionContainer = styled(ResponsiveGrid)(({ theme }) => ({
  marginBottom: 'var(--spacer-xxxl)',
  marginTop: 'var(--spacer-xxxl)',
}));

const Title = styled('h2')(({ theme }) => ({
  ...theme.typography.h2,
  textAlign: 'center',
  marginTop: 0,
  marginBottom: 'var(--spacer-l)',
}));

const Headline = styled('h4')(({ theme }) => ({
  ...theme.typography.h4,
  marginBottom: 'var(--spacer-l)',
  marginTop: 0,
}));

const Text = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  marginTop: 0,
  marginBottom: 'var(--spacer-l)',
}));
